<template>
  <div class="c-details-card">
    <div
      v-if="details"
    >
      <template v-for="detail in details">
        <featured-text-row
          :key="detail.handle"
          v-bind="detail"
        />
      </template>
    </div>
  </div>
</template>

<script>
import FeaturedTextRow from "../featuredProducts/FeaturedTextRow.vue";
export default {
  name: "DetailsCard",
  components: {
    FeaturedTextRow
  },
  props: {
    details: {
      type: Array,
      default: null
    },
    getProductFunction: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.c-details-card {
  padding: 10px;
}
</style>